import React, { Component } from "react";
import { connect } from "react-redux";
import {} from "../../redux/app/actions";
import {} from "../../redux/csDsp/actions";
import { showDetailEditerWindowAction } from "../../redux/ui/actions";
import {
  updateWLTrAction,
  updatePompTrAction,
  changeselMeaRowAction,
  updateScreenTrAction,
} from "../../redux/editer/actions";
import {
  addWLTrAction,
  addPompTrAction,
  changeWLTrSelRowAction,
  changePompTrSelRowAction,
  changeMeaSelRowAction,
  changeMeaTimeSelRowAction,
} from "../../redux/well/actions";
import Lgd, { probLgd } from "../common/Lgd";
import Sw from "../common/Sw";
import jschardet from "jschardet";

const mapStateToProps = (state) => {
  return {
    meaSelRow: state.wellReducer.meaSelRow,
    meaTimeSelRow: state.wellReducer.meaTimeSelRow,
    wlTrData: state.editerReducer.editerWlMeaData,
    pompTrData: state.editerReducer.editerPompMeaData,
    selMeaData: state.editerReducer.selMeaData,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    selMeaRow: state.editerReducer.selMeaRow,
    scrTrData: state.editerReducer.editerScreenData,
    checkPreInd: state.boringReducer.checkPreInd,
    detailCat: state.editerReducer.detailCat,
    userLicense: state.appReducer.userLicense,
  };
};

class Detail extends Component {
  constructor(props) {
    super(props);
    this.closeSw = this.closeSw.bind(this);
    if (this.props.detailCat == 0) {
      this.boringID1 = this.props.boringID1;
      this.boringID2 = this.props.boringID2;
    } else {
      this.boringID1 = 1000;
      this.boringID2 = this.props.checkPreInd;
    }
  }

  /*
   * 追加
   * @since ando 2023-8-10
   */
  addCat(cat) {
    if (cat == 0) {
      //水位データ
      if (!this.props.wlTrData[this.boringID1]) {
        this.props.wlTrData[this.boringID1] = {};
      }

      if (!this.props.wlTrData[this.boringID1][this.boringID2]) {
        this.props.wlTrData[this.boringID1][this.boringID2] = [];
      }
      const selWLTrData = this.props.wlTrData[this.boringID1][this.boringID2];
      const updatedWLTrMeaData = selWLTrData.concat({ time: 0, mea: 0 });

      // wellsTrData の更新
      const updatedWLTrData = {
        ...this.props.wlTrData,
        [this.boringID1]: {
          ...this.props.wlTrData[this.boringID1],
          [this.boringID2]: updatedWLTrMeaData,
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateWLTrAction(updatedWLTrData));
      console.log(this.props.wlTrData);
    } else if (cat == 1) {
      //揚水データ
      if (!this.props.pompTrData[this.boringID1]) {
        this.props.pompTrData[this.boringID1] = {};
      }

      if (!this.props.pompTrData[this.boringID1][this.boringID2]) {
        this.props.pompTrData[this.boringID1][this.boringID2] = [];
      }
      const selPompTrData =
        this.props.pompTrData[this.boringID1][this.boringID2];
      const updatedPompTrMeaData = selPompTrData.concat({ time: 0, mea: 0 });

      // wellsTrData の更新
      const updatedPompTrData = {
        ...this.props.pompTrData,
        [this.boringID1]: {
          ...this.props.pompTrData[this.boringID1],
          [this.boringID2]: updatedPompTrMeaData,
        },
      };
      this.props.dispatch(updatePompTrAction(updatedPompTrData));
    } else if (cat == 2) {
      //スクリーンデータ
      if (!this.props.scrTrData[this.boringID1]) {
        this.props.scrTrData[this.boringID1] = {};
      }

      if (!this.props.scrTrData[this.boringID1][this.boringID2]) {
        this.props.scrTrData[this.boringID1][this.boringID2] = [];
      }
      const selScrTrData = this.props.scrTrData[this.boringID1][this.boringID2];
      const updatedScrTrData = selScrTrData.concat({
        id: selScrTrData.length + 1,
        top: 0,
        low: 0,
      });

      // wellsTrData の更新
      const updatedScrTrData2 = {
        ...this.props.scrTrData,
        [this.boringID1]: {
          ...this.props.scrTrData[this.boringID1],
          [this.boringID2]: updatedScrTrData,
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateScreenTrAction(updatedScrTrData2));
    }
  }
  /*
   * 行削除
   * @since ando 2024-03-27
   */
  deleteSel(cat) {
    if (cat == 0) {
      if (!this.props.wlTrData[this.boringID1]) {
        this.props.wlTrData[this.boringID1] = {};
      }

      if (!this.props.wlTrData[this.boringID1][this.boringID2]) {
        this.props.wlTrData[this.boringID1][this.boringID2] = [];
      }
      const selWLTrData = this.props.wlTrData[this.boringID1][this.boringID2];
      const updatedWLTrMeaData = selWLTrData.filter(
        (el, i) => i != this.props.selMeaRow
      );
      // wellsTrData の更新
      const updatedWLTrData = {
        ...this.props.wlTrData,
        [this.boringID1]: {
          ...this.props.wlTrData[this.boringID1],
          [this.boringID2]: updatedWLTrMeaData,
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateWLTrAction(updatedWLTrData));
    } else if (cat == 1) {
      if (!this.props.pompTrData[this.boringID1]) {
        this.props.pompTrData[this.boringID1] = {};
      }

      if (!this.props.pompTrData[this.boringID1][this.boringID2]) {
        this.props.pompTrData[this.boringID1][this.boringID2] = [];
      }
      const selPompTrData =
        this.props.pompTrData[this.boringID1][this.boringID2];
      const updatedPompTrMeaData = selPompTrData.filter(
        (el, i) => i != this.props.selMeaRow
      );
      // wellsTrData の更新
      const updatedPompTrData = {
        ...this.props.pompTrData,
        [this.boringID1]: {
          ...this.props.pompTrData[this.boringID1],
          [this.boringID2]: updatedPompTrMeaData,
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updatePompTrAction(updatedPompTrData));
    } else if (cat == 2) {
      if (!this.props.scrTrData[this.boringID1]) {
        this.props.scrTrData[this.boringID1] = {};
      }

      if (!this.props.scrTrData[this.boringID1][this.boringID2]) {
        this.props.scrTrData[this.boringID1][this.boringID2] = [];
      }
      const selScrTrData = this.props.scrTrData[this.boringID1][this.boringID2];
      const updatedScrTrData = selScrTrData.filter(
        (el, i) => i != this.props.selMeaRow
      );
      // wellsTrData の更新
      const updatedScrTrDataWithNewIds = updatedScrTrData.map((el, i) => ({
        ...el,
        id: i + 1, // 新しいidを振り直す
      }));
      const updatedScrTrData2 = {
        ...this.props.scrTrData,
        [this.boringID1]: {
          ...this.props.scrTrData[this.boringID1],
          [this.boringID2]: updatedScrTrDataWithNewIds,
        },
      };

      // 新しい wellsTrData をセット
      this.props.dispatch(updateScreenTrAction(updatedScrTrData2));
    }
  }

  /*
   * テーブルクリック
   * @since ando 2024-07-29
   */
  changeRow = (e) => {
    e.target.closest("tbody").childNodes.forEach((el) => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");
    this.props.dispatch(changeselMeaRowAction(tr.id));
    console.log(`Row ${tr.id} clicked!`);
  };

  /*
   * テーブルデータ書き換え
   * @since ando 2024-07-29
   */
  changeField = (e, index, field, cat) => {
    // 例えば、選択された種別を取得する処理などを追加
    const changeField = e.target.value;
    if (isNaN(changeField) && field != "name") {
      alert("数値を入力してください。");
      return;
    }
    if (cat == 0) {
      const selWLTrData = this.props.wlTrData[this.boringID1][this.boringID2];
      const updatedMeaTrData = selWLTrData.map((el, i) => {
        if (i === index) {
          return { ...el, [field]: changeField };
        }
        return el;
      });
      const updatedWLTrData = {
        ...this.props.wlTrData,
        [this.boringID1]: {
          ...this.props.wlTrData[this.boringID1],
          [this.boringID2]: updatedMeaTrData,
        },
      };
      console.log(updatedWLTrData);
      // 新しい wellsTrData をセット
      this.props.dispatch(updateWLTrAction(updatedWLTrData));
    } else if (cat == 1) {
      const selPompTrData =
        this.props.pompTrData[this.boringID1][this.boringID2];
      const updatedMeaTrData = selPompTrData.map((el, i) => {
        if (i === index) {
          return { ...el, [field]: changeField };
        }
        return el;
      });
      const updatedPompTrData = {
        ...this.props.pompTrData,
        [this.boringID1]: {
          ...this.props.pompTrData[this.boringID1],
          [this.boringID2]: updatedMeaTrData,
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updatePompTrAction(updatedPompTrData));
    } else if (cat == 2) {
      const selScrTrData = this.props.scrTrData[this.boringID1][this.boringID2];
      const updatedScrTrData = selScrTrData.map((el, i) => {
        if (i === index) {
          return { ...el, [field]: changeField };
        }
        return el;
      });
      const updatedScrTrData2 = {
        ...this.props.scrTrData,
        [this.boringID1]: {
          ...this.props.scrTrData[this.boringID1],
          [this.boringID2]: updatedScrTrData,
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateScreenTrAction(updatedScrTrData2));
    }
  };
  /*
   * ファイルインポート
   * @since ando 2024-03-22
   */
  async fileImport(type) {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = (event) => {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      const fileSizeInBytes = file.size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // バイトをMBに変換
      console.log(fileSizeInMB);

      if (fileSizeInMB > 1) {
        alert("1MB以上のファイルはアップロードできません。");
        return;
      } else {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (event) => {
          const arrayBuffer = event.target.result;
          const byteArray = new Uint8Array(arrayBuffer);

          // Uint8Array を Buffer に変換
          const buffer = Buffer.from(byteArray);

          // jschardet でエンコーディングを判定（Buffer を渡す）
          const detected = jschardet.detect(buffer);
          // エンコーディングを判定後、必要に応じて処理
          let encoding = detected.encoding ? detected.encoding : "utf-8";
          if (
            [
              "ISO-8859-2",
              "ISO-8859-1",
              "windows-1252",
              "EUC-JP",
              "ISO-2022-JP",
              "CP932",
            ].includes(encoding)
          ) {
            encoding = "shift-jis"; // これらの場合、Shift-JIS に切り替える
          }
          const decoder = new TextDecoder(encoding);
          const contents = decoder.decode(new Uint8Array(arrayBuffer));
          let fileContentArray = contents.split(/\r\n|\n/).filter(Boolean);
          //テーブル内を初期化する
          if (type == 0) {
            this.props.dispatch(updateWLTrAction([]));
          } else {
            this.props.dispatch(updatePompTrAction([]));
          }
          //単位によって、倍率を決定する。
          let unitS = fileContentArray[0].split(",")[0];
          let unit;
          switch (unitS) {
            case "s":
              unit = 86400;
              break;
            case "m":
              unit = 1440;
              break;
            case "h":
              unit = 24;
              break;
            case "d":
              unit = 1;
              break;
            default:
              unit = 1;
              break;
          }
          let data = [];
          // 計測値を格納
          for (let i = 1; i < fileContentArray.length; i++) {
            const row = fileContentArray[i].split(",");
            if (isNaN(row[0]) || isNaN(row[1])) {
              alert("数値以外のデータが含まれています。");
              break;
            } else {
              const modTime = parseFloat(row[0]) / unit;
              data.push({ time: modTime.toFixed(5), mea: parseFloat(row[1]) });
            }
          }
          if (type == 0) {
            const updatedWLTrData = {
              ...this.props.wlTrData,
              [this.boringID1]: {
                ...this.props.wlTrData[this.boringID1],
                [this.boringID2]: data,
              },
            };
            console.log(updatedWLTrData);
            // 新しい wellsTrData をセット
            this.props.dispatch(updateWLTrAction(updatedWLTrData));
          } else {
            const updatedPompTrData = {
              ...this.props.pompTrData,
              [this.boringID1]: {
                ...this.props.pompTrData[this.boringID1],
                [this.boringID2]: data,
              },
            };
            // 新しい wellsTrData をセット
            this.props.dispatch(updatePompTrAction(updatedPompTrData));
          }

          // ファイルの内容をテーブルデータに登録する
          //カンマ区切りで3列か確認する。
        };
        //this.waiting(false);
        const a = 1;
      }
    };
    fileInput.click();
  }
  /*
   * 表示/非表示を切り替える
   * @since ando 2023-08-08
   */
  changeVisible(e, id) {
    const div1 = document.getElementById(id);
    if (div1.style.display == "block") {
      // noneで非表示
      div1.style.display = "none";
    } else {
      // blockで表示
      div1.style.display = "block";
    }
  }
  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    this.props.dispatch(showDetailEditerWindowAction(false));
  }

  render() {
    return (
      <div>
        <Sw title="詳細情報" focusName="detail">
          {/*
                    <fieldset className='Unit l-mtSSS'>
                        <legend> 井戸寸法</legend>
                        <div id='idoSize'>
                            <div>
                                <label className='wl_label'>半径(m)：</label><input className='textSSR' type='text' value={this.props.analyRadius} onChange={e => this.changeIdoPram(e, "ar")} onBlur={e => this.checkIdoPram(e, "ar")} />
                                <label className='wl_label'>下端深度(m)：</label><input className='textSSR' type='text' value={this.props.analyBHHeight} onChange={e => this.changeIdoPram(e, "ah")} onBlur={e => this.checkIdoPram(e, "ah")} />
                            </div>
                            <div>
                                <label className='wl_label'>ポンプ位置深度(m)：</label><input className='textSSR' type='text' value={this.props.analyPump} onChange={e => this.changeIdoPram(e, "ap")} onBlur={e => this.checkIdoPram(e, "ap")} />
                                <label className='wl_label'>初期水位深度(m)：</label><input className='textSSR' type='text' value={this.props.analyWL} onChange={e => this.changeIdoPram(e, "aw")} onBlur={e => this.checkIdoPram(e, "aw")} />
                            </div>
                        </div>
                        <div id='idoSize' className="optCheck">
                            <div>
                                <label className='wl_label'>半径(m)：</label><input className='textSSR' type='text' value={this.props.analyRadius} onChange={e => this.changeIdoPram(e, "ar")} onBlur={e => this.checkIdoPram(e, "ar")} />
                                <label className='wl_label'>下端深度(m)：</label><input className='textSSR' type='text' value={this.props.analyBHHeight} onChange={e => this.changeIdoPram(e, "ah")} onBlur={e => this.checkIdoPram(e, "ah")} />
                            </div>
                            <div>
                                <label className='wl_label'>ポンプ位置深度(m)：</label><input className='textSSR' type='text' value={this.props.analyPump} onChange={e => this.changeIdoPram(e, "ap")} onBlur={e => this.checkIdoPram(e, "ap")} />
                                <label className='wl_label'>初期水位深度(m)：</label><input className='textSSR' type='text' value={this.props.analyWL} onChange={e => this.changeIdoPram(e, "aw")} onBlur={e => this.checkIdoPram(e, "aw")} />
                            </div>
                        </div>
                    </fieldset>

                    <legend>　</legend>
                    */}
          <div className="l-flex">
            <div>
              <legend> 水位データ</legend>
              <div className="l-flex">
                <button className="sBtn" onClick={() => this.addCat(0)}>
                  追加
                </button>
                <button className="sBtn" onClick={() => this.deleteSel(0)}>
                  削除
                </button>
                <button className="sBtn" onClick={() => this.fileImport(0)}>
                  インポート
                </button>
              </div>
              <div
                className="MeaInput2 l-mtSSS"
                style={{ overflowY: "scroll" }}
              >
                <table className="idoTable">
                  <thead>
                    <tr>
                      <th className="tsS">時間(d)</th>
                      <th className="tsS">水位低下量(m)</th>
                    </tr>
                  </thead>
                  <tbody ref={(ref) => (this.tbRef = ref)}>
                    {this.props.wlTrData[this.boringID1] !== undefined &&
                      this.props.wlTrData[this.boringID1][this.boringID2] !==
                        undefined &&
                      this.props.wlTrData[this.boringID1][this.boringID2].map(
                        (el, index) => (
                          <tr
                            id={index}
                            key={index}
                            onClick={(e) => this.changeRow(e, 0)}
                          >
                            <td>
                              <input
                                className="textTR"
                                type="text"
                                value={el.time}
                                onChange={(e) =>
                                  this.changeField(e, index, "time", 0)
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="textTR"
                                type="text"
                                value={el.mea}
                                onChange={(e) =>
                                  this.changeField(e, index, "mea", 0)
                                }
                              />
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>
            </div>
            <legend>　</legend>
            <div>
              <legend> 揚水データ</legend>
              <div className="l-flex">
                <button className="sBtn" onClick={() => this.addCat(1)}>
                  追加
                </button>
                <button className="sBtn" onClick={() => this.deleteSel(1)}>
                  削除
                </button>
                <button className="sBtn" onClick={() => this.fileImport(1)}>
                  インポート
                </button>
              </div>
              <div
                className="MeaInput2 l-mtSSS"
                style={{ overflowY: "scroll" }}
              >
                <table className="idoTable">
                  <thead>
                    <tr>
                      <th className="tsS">時間(d)</th>
                      <th className="tsS">
                        揚水量(m<sup>3</sup>/d)
                      </th>
                    </tr>
                  </thead>
                  <tbody ref={(ref) => (this.tbRef = ref)}>
                    {this.props.pompTrData[this.boringID1] !== undefined &&
                      this.props.pompTrData[this.boringID1][this.boringID2] !==
                        undefined &&
                      this.props.pompTrData[this.boringID1][this.boringID2].map(
                        (el, index) => (
                          <tr
                            id={index}
                            key={index}
                            onClick={(e) => this.changeRow(e, 0)}
                          >
                            <td>
                              <input
                                className="textTR"
                                type="text"
                                value={el.time}
                                onChange={(e) =>
                                  this.changeField(e, index, "time", 1)
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="textTR"
                                type="text"
                                value={el.mea}
                                onChange={(e) =>
                                  this.changeField(e, index, "mea", 1)
                                }
                              />
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <legend>　</legend>
          <legend>スクリーン深度オプション</legend>
          <div className="l-flex">
            <button className="sBtn" onClick={() => this.addCat(2)}>
              追加
            </button>
            <button className="sBtn" onClick={() => this.deleteSel(2)}>
              削除
            </button>
          </div>
          <div className="MeaInput2 l-mtSSS" style={{ overflowY: "scroll" }}>
            <table className="idoTable">
              <thead>
                <tr>
                  <th className="tsS">ID</th>
                  <th className="tsS">上端深度[m]</th>
                  <th className="tsS">下端深度[m]</th>
                </tr>
              </thead>
              <tbody ref={(ref) => (this.tbRef = ref)}>
                {this.props.scrTrData[this.boringID1] !== undefined &&
                  this.props.scrTrData[this.boringID1][this.boringID2] !==
                    undefined &&
                  this.props.scrTrData[this.boringID1][this.boringID2].map(
                    (el, index) => (
                      <tr
                        id={index}
                        key={index}
                        onClick={(e) => this.changeRow(e, 0)}
                      >
                        <td>
                          <input className="textTR" type="text" value={el.id} />
                        </td>
                        <td>
                          <input
                            className="textTR"
                            type="text"
                            value={el.top}
                            onChange={(e) =>
                              this.changeField(e, index, "top", 2)
                            }
                          />
                        </td>
                        <td>
                          <input
                            className="textTR"
                            type="text"
                            value={el.low}
                            onChange={(e) =>
                              this.changeField(e, index, "low", 2)
                            }
                          />
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>

          <div className="l-right l-mtM">
            <button className="cBtn l-mlS" onClick={this.closeSw}>
              閉じる
            </button>
          </div>
        </Sw>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Detail);
